import { api } from '../../api/config';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import Loader from '../../components/Loader/Loader';
import SlugPageContent from '../../components/core/slug/slug-page-content';
import { Box } from '@mui/material';

export default function BlogContent() {
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [searchParams] = useSearchParams();
    const reduxLanguage = useSelector(state => state.language.language);
    const urlLanguage = searchParams.get("lang");

    const language = urlLanguage || reduxLanguage;

    function safeDecode(str) {
        if (!str.includes("&")) return str;
        var doc = new DOMParser().parseFromString(str, 'text/html');
        return doc.documentElement.textContent;
    }
    const navigate = useNavigate();
    const path = window.location.pathname.split('/');

    const [slugs, setSlugs] = useState();
    const [data, setData] = useState();

    const getData = () => {
        setLoading(true);
        api.post('/page/postgetSlug', { lang: language, slug: id })
            .then(res => {
                console.log(res.data.data);
                if (res.data.success === true) {
                    setSlugs({
                        alb: res.data.data.translations['alb']?.slug,
                        eng: res.data.data.translations['eng']?.slug
                    });
                    setData(res.data.data)
                }
            })
            .finally(() => {
                setLoading(false);
            })
    }
    console.log(slugs);
    useEffect(() => {
        getData();
        window.scrollTo(0, 0);
        // eslint-disable-next-line
    }, [id, language]);

    return (
        !loading ?
            <Box sx={{ overflow: 'hidden' }}>
                <SlugPageContent content={data.translations[language].content} />
            </Box>
            :
            <Loader state={loading} />
    )
}